// Modules/Index.js
import React, { useEffect, useState } from 'react';
import Navbar from '../../Components/Common/Navbar';
import Footer from '../../Components/Common/Footer';
import HeroSectionCompact from '../../Components/Sections/HeroSectionCompact';
import FeaturesSection from '../../Components/Sections/FeaturesSection';
import TestimonialsSection from '../../Components/Sections/TestimonialsSection';
import DemoSection from '../../Components/Sections/DemoSection';
import ProductFeaturesSection from '../../Components/Sections/ProductFeaturesSection';
import PackagesSection from '../../Components/Sections/PackagesSection';
import SupportSection from '../../Components/Sections/SupportSection';
import TeamSection from '../../Components/Sections/TeamSection';
import VisitSection from '../../Components/Sections/VisitSection';
import FAQSection from '../../Components/Sections/FAQSection';
import ContactSection from '../../Components/Sections/ContactSection';
import LoginModal from '../../Components/Common/LoginModal';
import indexAPI from './IndexAPI';
import { useSearchParams } from 'react-router-dom';
import { getImagePath } from '../../Utils/Utilities';
import { useBrand } from '../../Utils/BrandContext';
import PopupQuestions from '../../Components/Sections/PopupQuestions';
import FeaturesScrollable from '../../Components/Sections/FeaturesScrollable';
import FeaturesCompact from '../../Components/Sections/FeaturesCompact';
import StickyPricingFooter from '../../Components/Sections/StickyPricingFooter';
import HeroSection from '../../Components/Sections/HeroSections';
import ProductFeatures from '../../Components/Sections/ProductFeatures';
import { useIsMobile } from '../../Hooks/useIsMobile';
import SupportDesktopSection from '../../Components/Sections/SupportDesktopSection';
import GoLiveSection from '../../Components/Sections/GoLiveSection';
import { currPage } from '../../Constants/Packages';

const IndexPage = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { brand: activeBrand } = useBrand();
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const isMobile = useIsMobile();

  const rfdAvl = false;
  const flashOfferOn = true
  const isMidnight = [0, 1, 23].includes(new Date().getHours());

  const brandLogo = activeBrand === 'bz' ? getImagePath("/Images/Biziverse.png") : getImagePath("/Images/QikERP.png");
  // Handle scroll on mount - either to hash section or top
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      // Wait for components to render
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          const navbarHeight = 70;
          const targetPosition = element.offsetTop - navbarHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Force scroll to top if no hash
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, []);

  const handleLoginClick = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      const navbarHeight = 70;
      const targetPosition = heroSection.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      setTimeout(() => {
        const mobileInput = document.getElementById('mobile');
        if (mobileInput) {
          mobileInput.focus();
        }
      }, 600);
    }
  };

  const handleLogin = async (mobileNumber) => {
    setLoading(true);

    try {
      const result = await indexAPI.handleLogin(mobileNumber, activeBrand);

      // Redirect based on response
      window.location.href = result.redirectUrl;

    } catch (err) {
      alert(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleScrollToPricing = () => {
    // Add a small delay to ensure modal is fully closed and state is settled
    setTimeout(() => {
      const packagesSection = document.getElementById('simplePricing');
      if (packagesSection) {
        const navbarHeight = 70;
        const targetPosition = packagesSection.offsetTop - navbarHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      } else {
        console.warn('Pricing section not found');
      }
    }, 100);
  };

  const handleBuyNow = (editionId) => {
    if (isMobile) {

      setLoginModalOpen(true);
    } else {
      const heroSection = document.getElementById('hero-section');
      if (heroSection) {
        const navbarHeight = 70;
        const targetPosition = heroSection.offsetTop - navbarHeight;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        setTimeout(() => {
          const mobileInput = document.getElementById('mobile');
          if (mobileInput) mobileInput.focus();
        }, 600);
      }
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar
        logo={brandLogo}
        onLoginClick={handleLoginClick}
        isFromIdx={true}
        onLogin={handleLogin}
        loginModalOpen={loginModalOpen}
        onLoginModalOpen={setLoginModalOpen}
      />

      <main>
        {/* <HeroSection
          onGetStarted={handleLogin}
          onLogin={handleLogin}
          loading={loading}
          rfdAvl={rfdAvl}
          flashOfferOn={flashOfferOn}
          isMidnight={isMidnight}
          logo={brandLogo}
          id="hero-section"
        /> */}
        <HeroSectionCompact
          onGetStarted={handleLogin}
          onLogin={handleLogin}
          pageName={currPage}
          isFromIdx={true}
        />
        {useIsMobile() && <FeaturesSection onBuyNow={() => { setLoginModalOpen(true) }} pricing={{ silver: 2999, gold: 4999 }} onLogin={handleLogin}
          pageName={currPage}
          rfdAvl={rfdAvl} isFromIdx={true}
        />}

        {useIsMobile() && <DemoSection />}

        <ProductFeatures onBuyNow={handleScrollToPricing} />
        {!useIsMobile() && <SupportDesktopSection />}
        {/* <TestimonialsSection /> */}


        {false && <PopupQuestions />}

        {false && <div id="features" className="md:scroll-m-0">
          <FeaturesScrollable />
        </div>}

        {false && <div id="features" className="md:hidden">
          <FeaturesCompact />
        </div>}

        {false && <ProductFeaturesSection onBuyNow={handleScrollToPricing} />}

        {/* Packages/Pricing Section */}
        <PackagesSection
          onBuyNow={handleBuyNow}
          pageName={currPage}
          isFromWebsite={true}
        />
        <GoLiveSection />
        <TestimonialsSection brandLogo={brandLogo} />

        {/* Support Section */}
        <SupportSection />

        <TeamSection />

        <VisitSection />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />
      <StickyPricingFooter
        onBuyNow={handleScrollToPricing}
        pageName={currPage}
      />

      {/* Login Modal - Rendered at root level for proper backdrop coverage */}
      <LoginModal
        isOpen={loginModalOpen}
        onClose={() => setLoginModalOpen(false)}
        onLogin={handleLogin}
        logo={brandLogo}
      />
    </div>
  );
};

export default IndexPage;